import React from "react";
import { HashRouter as BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts";
import { WebRouter } from "./router/WebRouter";
import { AdminRouter } from "./router/AdminRouter";
import { AssistanceRouter } from "./router/AssistanceRouter";
import { AssistanceRouterPublic } from "./router/AssistanceRouterPublic";
import { Assistance3dRouter } from "./router/Assistance3dRouter";
import { AuthInstitutionRouter } from "./router/AuthInstitutions";

// 📦 Ant Design global config
import { ConfigProvider } from "antd";
import esES from "antd/locale/es_ES";
import dayjs from "dayjs";
import "dayjs/locale/es";

dayjs.locale("es");

export default function App() {
  return (
    <AuthProvider>
      <ConfigProvider locale={esES}>
        <BrowserRouter>
          <Routes>
            {/* Rutas principales del sitio web */}
            <Route path="/*" element={<WebRouter />} />
            <Route path="/login/*" element={<AuthInstitutionRouter />} />
            <Route path="/admin/*" element={<AdminRouter />} />
            <Route path="/assistanceChat/*" element={<AssistanceRouter />} />
            <Route
              path="/assistancechatpublic/*"
              element={<AssistanceRouterPublic />}
            />
            <Route
              path="/assistanceChat3d/*"
              element={<Assistance3dRouter />}
            />
          </Routes>
        </BrowserRouter>
      </ConfigProvider>
    </AuthProvider>
  );
}
